import script from "./RevenueAllocationTabV2.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueAllocationTabV2.vue?vue&type=script&setup=true&lang=js"

import "./RevenueAllocationTabV2.vue?vue&type=style&index=0&id=c8fa4682&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8fa4682"]])

export default __exports__